(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/selfservice-cart/assets/javascripts/full-cart/cart.js') >= 0) return;  svs.modules.push('/components/components/selfservice-cart/assets/javascripts/full-cart/cart.js');
"use strict";



const _svs$components$selfs = svs.components.selfserviceCart.fullCart,
  CartNavFooter = _svs$components$selfs.CartNavFooter,
  CartNavHeader = _svs$components$selfs.CartNavHeader,
  CartItemList = _svs$components$selfs.CartItemList,
  CartInfo = _svs$components$selfs.CartInfo,
  EmptyCart = _svs$components$selfs.EmptyCart;
const closeCart = svs.components.selfserviceCart.reduxActions.closeCart;
const _ReactRedux = ReactRedux,
  useDispatch = _ReactRedux.useDispatch,
  useSelector = _ReactRedux.useSelector;
function getTotalCost(items) {
  let cost = 0;
  items.forEach(item => {
    cost += item.productProperties.cost;
  });
  return cost;
}
const Cart = _ref => {
  let onPlayMore = _ref.onPlayMore,
    onFinished = _ref.onFinished;
  const items = useSelector(state => state.items);
  const productCount = items ? items.length : 0;
  const totalPrice = items ? getTotalCost(items) : 0;
  const dispatch = useDispatch();
  const isOpen = useSelector(state => state.cartOpen);
  function onClose() {
    dispatch(closeCart());
  }
  const rootClasses = "ss-cart-container".concat(isOpen ? ' ss-cart-container-open' : '');
  return React.createElement("div", {
    className: rootClasses
  }, React.createElement(CartNavHeader, {
    numItems: productCount,
    onClose: onClose
  }), React.createElement("div", {
    className: "ss-cart-center"
  }, productCount > 0 ? React.createElement(React.Fragment, null, React.createElement("div", {
    className: "ss-cart-items"
  }, React.createElement("div", {
    className: "ss-cart-items-inner"
  }, React.createElement(CartItemList, {
    tenant: "tb"
  }), React.createElement(CartItemList, {
    tenant: "lb"
  }))), React.createElement(CartInfo, {
    amountOfItems: productCount,
    totalItemCost: totalPrice
  })) : React.createElement(EmptyCart, {
    onPlayMore: onPlayMore
  })), productCount > 0 && React.createElement(CartNavFooter, {
    onFinished: () => onFinished(items),
    onPlayMore: onPlayMore
  }));
};
setGlobal('svs.components.selfserviceCart.fullCart.Cart', Cart);

 })(window);